export let fetchCountry = (useCase) => {
    const countryMap = {
        FRANCE: "FRANCE",
        FRANCE_WITHHOLDING: "FRANCE_WITHHOLDING",
        NOR: "NORWAY",
        CZ: "CZECH_REPUBLIC",
        LUX: "LUXEMBOURG",
        CZ_VAT: "CZ_VAT",
        CZ_ESL: "CZ_ESL",
        CZ_VLS: "CZ_VLS",
        CZ_CIT: "CZ_CIT",
        CA: "CANADA",
        CA_DST: "CA_DST",
        LUX_IOSS: "LUX_IOSS",
        LUX_UOSS: "LUX_UOSS",
        LUX_NUOSS: "LUX_NUOSS",
        DE: "GERMANY",
        DE_VAT: "DE_VAT",
        DE_VAT_TEST: "DE_VAT_TEST",
        PL: "POLAND",
        PL_CIT: "PL_CIT",
        PL_INTRASTAT: "PL_INTRASTAT",
        IT: "ITALY",
        MY: "MALAYSIA",
        TR: "TURKEY",
        TR_WITHHOLDING: "TURKEY_WITHHOLDING"
    }
    if (useCase in countryMap) {
        return countryMap[useCase]
    } else {
        return "Compliance"
    }
}
